import baseURLv1 from '@/services/APIConfig.js';
import { add, append, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    logs: [],
    hasNext: false,
    filters: {
      action_user: '',
      action_name: '',
      severity: '',
      action_date_from: '',
      action_date_to: '',
      orderBy: '-action_date',
    },
    page: 1,
  },
  mutations: {
    set,
    update,
    add,
    append,

    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
    },
  },
  actions: {
    async loadLogs({ state, commit }, { foreignerId }) {
      const response = await this.$axios.get(`${baseURLv1}/foreigner/${foreignerId}/audit/log/`, {
        params: {
          order_by: state.filters.orderBy,
          action_user: state.filters.action_user,
          action_name: state.filters.action_name,
          severity: state.filters.severity,
          action_date_from: state.filters.action_date_from,
          action_date_to: state.filters.action_date_to,
          page: state.page,
          page_size: 50,
        },
      });

      // TODO: nastylovat load more button, přidat total a skryt pokud už není další page
      commit('set', ['hasNext', Boolean(response.data.next)]);
      commit(state.page === 1 ? 'set' : 'append', ['logs', response.data.data]);
    },
  },
};
